<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-handshake"></i></span>
    <h1>Find a Partner</h1>
    <p class="static-subtitle">Get expert help setting up and running orderYaa ERP.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        orderYaa ERP is built to be set up on your own, but many businesses prefer working with
        an implementation partner for data migration, staff training, or custom configuration.
        Our partner network can help you get up and running faster.
      </p>

      <h2>What partners help with</h2>
      <ul>
        <li>Initial setup — company, branches, business units, and chart of accounts</li>
        <li>Migrating products, customers, and vendors from your existing system</li>
        <li>Staff training on POS, inventory, and back-office workflows</li>
        <li>Custom reports, integrations, and module configuration</li>
      </ul>

      <h2>Request a partner</h2>
      <p>
        Tell us a bit about your business and location, and we'll connect you with a partner who
        fits your needs.
      </p>

      <div class="static-cta">
        <a class="btn" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a call to find a partner</a>
      </div>
    </div>
  </div>
</section>
